import { BatchPredictionMonitorDataName } from "./BatchPredictionMonitorDataName";

export class BatchPredictionMonitorData {
  /**
   * Create a Batch Prediction Monitor Data
   * @param {string[]} header - monitor data header
   * @param {*} rows - monitor data rows
   * @param {BatchPredictionMonitorDataName[]} names - monitor data names
   */
  constructor(header = [], rows = [], names = []) {
    /** @type {string[]} */
    this.header = header;

    /** @type {*[]} */
    this.rows = rows;

    /** @type {BatchPredictionMonitorDataName[]} */
    this.names = names;
  }

  /**
   * Map data from api to instance of BatchPredictionMonitorData
   * @returns {BatchPredictionMonitorData} new instance with the mapped data
   */
  static fromApi({ header, data, names }) {
    return new BatchPredictionMonitorData(header, data, names.map(BatchPredictionMonitorDataName.fromApi));
  }

  /**
   * @returns a copy of the header
   */
  getHeader() {
    return [...this.header];
  }

  /**
   * @returns a copy of the rows
   */
  getRows() {
    return [...this.rows];
  }

  /**
   * @param {*[]} rows
   */
  appendRows(rows) {
    this.rows.push(...rows);
  }

  /**
   * @returns a copy of the names
   */
  getNames() {
    return [...this.names];
  }

  /**
   * @returns the cloned instance
   */
  clone() {
    return new BatchPredictionMonitorData(this.getHeader(), this.getRows(), this.getNames());
  }
}
